import flat from 'flat'

/**
 * Replaces placeholders in a string with corresponding values from a context object.
 *
 * @param {string} href - The input string containing placeholders in the format {key}.
 * @param {any} ctx - The context object containing key-value pairs for replacement.
 * @returns {string} The input string with placeholders replaced by corresponding values.
 *
 * @example
 * const template = "Hello, {name}! Your order {order.id} will arrive on {order.date}.";
 * const context = { name: "John", order: { id: "12345", date: "2023-05-15" } };
 * const result = stringTemplating(template, context);
 * // result: "Hello, John! Your order 12345 will arrive on 2023-05-15."
 */

export const stringTemplating = (href: string, ctx: any) =>
	href.replace(/{[\w.]+}/gm, (match: string) => {
		const flatCtx: Record<string, any> = flat(ctx)
		const key = match.replace(/[{}]/gm, '')

		return flatCtx[key] || ''
	})
